import React from "react";

const V = {
  primary:   "bg-p text-white border-0",
  secondary: "bg-s text-t1 border-[1.5px] border-b1",
  ghost:     "bg-transparent text-t2 border-0",
  danger:    "bg-rb text-r border-[1.5px] border-rd",
  success:   "bg-gb text-g border-[1.5px] border-gd",
};

export const Btn = ({ children, onClick, disabled, variant = "primary", icon: Ic, full, style }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={style}
    className={`flex items-center justify-center gap-2 px-[18px] py-[14px] rounded-xl text-[16px] font-semibold min-h-[48px] ${V[variant] || V.primary} ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer opacity-100"} ${full ? "w-full" : "w-auto"}`}
  >
    {Ic && <Ic size={18} />}
    {children}
  </button>
);
